
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.567 0H4.433C2.058 0 0 2.058 0 4.433v51.134C0 57.942 2.058 60 4.433 60h51.134C57.942 60 60 57.942 60 55.567V4.433C60 2.058 58.1 0 55.567 0zm1.267 55.567c0 .633-.634 1.267-1.267 1.267H4.433c-.634 0-1.267-.634-1.267-1.267V4.433c0-.634.633-1.267 1.267-1.267h51.134c.633 0 1.267.633 1.267 1.267v51.134z"}}),_c('path',{attrs:{"d":"M16.306 11.715c-2.375 0-3.958 1.583-3.958 3.8 0 2.058 1.583 3.799 3.958 3.799 2.533 0 4.116-1.741 4.116-3.8-.158-2.216-1.583-3.799-4.116-3.799zM20.105 22.322h-7.599v24.38h7.6v-24.38zM38.945 21.689c-4.116 0-6.491 2.374-7.441 3.957h-.158l-.317-3.324h-6.49c.158 2.216.158 4.75.158 7.757v16.623h7.599v-14.09c0-.633 0-1.425.316-1.9.475-1.424 1.742-2.85 3.958-2.85 2.691 0 3.8 2.217 3.8 5.225v13.456h7.598V32.138c-.316-7.124-3.957-10.448-9.023-10.448z"}})])
          )
        }
      }
    